import { uuid25 } from "../../uuid/dist/uuid25.js";
import { arrayHas } from "../arrayHas.js";
import { isNil, isNumber, isPlainObject, isString } from "es-toolkit";
//#region src/utils/table-clipboard/payload.ts
var CLIPBOARD_MIME = "application/x-erd-editor";
var CLIPBOARD_FORMAT = "erd-editor-clipboard";
var CLIPBOARD_HTML_ATTR = "data-erd-editor";
var CLIPBOARD_HTML_TRUNCATED_ATTR = "data-erd-editor-truncated";
var HTML_PAYLOAD_MAX_BYTES = 1e6;
var PayloadKind = {
	tables: "tables",
	columns: "columns"
};
var hasPayloadKind = arrayHas(Object.values(PayloadKind));
function createPayload({ kind, copyId = uuid25(), tables = [], columns = [], memos = [], relationships = [], indexes = [] }) {
	return {
		format: CLIPBOARD_FORMAT,
		version: 1,
		copyId,
		kind,
		tables,
		columns,
		memos,
		relationships,
		indexes
	};
}
function parsePayload(json) {
	let raw;
	try {
		raw = JSON.parse(json);
	} catch {
		return { status: "foreign" };
	}
	if (!isPlainObject(raw)) return { status: "foreign" };
	if (raw.format !== "erd-editor-clipboard") return { status: "foreign" };
	const version = isNumber(raw.version) ? raw.version : NaN;
	if (!Number.isInteger(version)) return {
		status: "unsupported",
		version
	};
	if (version > 1) return {
		status: "unsupported",
		version
	};
	if (!isSupportedStructure(raw)) return {
		status: "unsupported",
		version
	};
	return {
		status: "ok",
		payload: migratePayload(raw)
	};
}
function isSupportedStructure(raw) {
	return isString(raw.kind) && hasPayloadKind(raw.kind) && Array.isArray(raw.tables) && Array.isArray(raw.columns) && Array.isArray(raw.memos) && isOptionalArray(raw.relationships) && isOptionalArray(raw.indexes);
}
function isOptionalArray(value) {
	return isNil(value) || Array.isArray(value);
}
function migratePayload(payload) {
	let next = payload;
	while (next.version < 1) {
		const from = next.version;
		next = {
			...next,
			version: from + 1
		};
	}
	return next;
}
//#endregion
export { CLIPBOARD_FORMAT, CLIPBOARD_HTML_ATTR, CLIPBOARD_HTML_TRUNCATED_ATTR, CLIPBOARD_MIME, HTML_PAYLOAD_MAX_BYTES, PayloadKind, createPayload, migratePayload, parsePayload };
